<template>
    <div>
        <forgot-pass :returnUrl="returnUrl" />
    </div>
</template>
<script>
    import forgotPass from '@/components/ForgotPass'

    export default {
        name: 'forgot-pass-view',
        components: {
            forgotPass,
        },
        props: {
            returnUrl: {
                default: '',
                type: String
            },
        },
    }
</script>
